<script>
export default {
  name: "IndicatorDisplay2",
  props: {
    indicator: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      animatedValue: 0,
    };
  },
  computed: {
    isPercentage() {
      return this.indicator.type === "perc";
    },
    displayValue() {
      if (this.isPercentage) {
        return `${this.animatedValue.toFixed(this.indicator.decimals)}%`;
      }
      return `${this.animatedValue.toFixed(this.indicator.decimals)} ${this
        .indicator.unit || ""}`;
    },
    progressValue() {
      if (this.isPercentage) {
        return (this.animatedValue / 100) * this.indicator.tot;
      }
      return (this.indicator.value / this.indicator.tot) * 100;
    },
    progressColor() {
      const value = this.isPercentage
        ? this.animatedValue
        : (this.indicator.value / this.indicator.tot) * 100;
      if (value < 50) {
        return "#f44336"; // red
      } else if (value < 75) {
        return "#ffc107"; // yellow
      } else {
        return "#4caf50"; // green
      }
    },
    strokeDasharray() {
      if (this.isPercentage) {
        return `${(this.animatedValue / 100) * 100}, 100`;
      } else {
        return `${(this.indicator.value / this.indicator.tot) * 100}, 100`;
      }
    },
  },
  mounted() {
    if (this.isPercentage) {
      this.animateValue(
        0,
        (this.indicator.value / this.indicator.tot) * 100,
        1000
      );
    } else {
      this.animateValue(0, this.indicator.value, 1000);
    }
  },
  methods: {
    animateValue(start, end, duration) {
      let startTimestamp = null;
      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        this.animatedValue = progress * (end - start) + start;
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    },
  },
};
</script>
<template>
  <div
    :class="
      isPercentage ? 'indicator-display-circle' : 'indicator-display-square'
    "
  >
    <div v-if="isPercentage" class="circle">
      <div class="circle-inner">
        <svg viewBox="0 0 36 36" class="circular-chart">
          <path
            class="circle-bg"
            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          />
          <path
            class="circle-progress"
            :stroke-dasharray="strokeDasharray"
            :stroke="progressColor"
            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          />
        </svg>
        <div class="circle-content">
          <h3>{{ indicator.title }}</h3>
          <p>{{ displayValue }}</p>
        </div>
      </div>
    </div>
    <div v-else class="card">
      <div class="card-content">
        <h3>{{ indicator.title }}</h3>
        <p>{{ displayValue }}</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.indicator-display-circle {
  display: flex;
  justify-content: center;
  align-items: center;
}

.indicator-display-square {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle {
  position: relative;
  width: 160px;
  height: 160px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 50%;
}
.card {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
}

.card {
  border-radius: 5px;
}

.circle-inner {
  position: relative;
  width: 160px;
  height: 160px;
}

.circular-chart {
  display: block;
  margin: 0px auto;
  max-width: 100%;
  max-height: 250px;
}

.circle-bg {
  fill: none;
  stroke: #eee;
  stroke-width: 4.5;
}

.circle-progress {
  fill: none;
  stroke-width: 4.5;
  stroke-linecap: round;
  transition: stroke-dasharray 0.6s ease 0s;
}

.circle-content,
.card-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.circle-content h3,
.card-content h3 {
  font-size: 14px;
  margin: 0;
  color: #4caf50;
}

.circle-content p,
.card-content p {
  font-size: 18px;
  margin: 5px 0 0;
  font-weight: bold;
}
</style>
